import { render, staticRenderFns } from "./FormTrainingSystem.vue?vue&type=template&id=421844d1&scoped=true&"
import script from "./FormTrainingSystem.vue?vue&type=script&lang=js&"
export * from "./FormTrainingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421844d1",
  null
  
)

export default component.exports